import { CacheProvider } from '@emotion/react';
import { UnheadProvider, createHead } from '@unhead/react/client';
import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppShell from './AppShell';
import { createEmotionCache } from './emotionCache';
import { Product } from './utils/models/products';

declare global {
    interface Window {
        __INITIAL_STATE__?: { products?: Product[] };
    }
}

const container = document.getElementById('root');
if (!container) {
    throw new Error('Failed to find the root element');
}

const initialProducts = window.__INITIAL_STATE__?.products;
const head = createHead();
const cache = createEmotionCache();

const app = (
    <StrictMode>
        <UnheadProvider head={head}>
            <CacheProvider value={cache}>
                <BrowserRouter>
                    <AppShell initialProducts={initialProducts} />
                </BrowserRouter>
            </CacheProvider>
        </UnheadProvider>
    </StrictMode>
);

// Prerendered routes ship server-rendered markup inside #root -> hydrate it.
// The SPA fallback shell ships an empty #root -> mount fresh.
if (container.hasChildNodes()) {
    hydrateRoot(container, app);
} else {
    createRoot(container).render(app);
}
